import { ModalContent } from '@creditornot/cbt-modal';
import React, { useEffect, useState } from 'react';
import { Form } from 'react-final-form';
import { FormattedMessage } from 'react-intl';

import { Brand } from 'apis/enterprise/types';
import validateYupSchema from 'common/utils/validateYupSchema';
import useGetBrandVenues from 'modules/brand/hooks/useGetBrandVenues';

import { AddEditVenueGroup, FormValues as AddEditVenueGroupFormValues } from './AddEditVenueGroup';
import { createEditVenueGroupSchema } from './schema';
import { Error, Loading, WoltModal } from './styles';
import {
  AddVenuesToVenueGroup,
  FormValues as AddVenuesToVenueGroupFormValues,
} from '../AddVenuesToVenueGroupModal/AddVenuesToVenueGroup';

export type FormValues = AddEditVenueGroupFormValues & AddVenuesToVenueGroupFormValues;

enum FormStep {
  CREATE_VENUE_GROUP = 'create-venue-group',
  ADD_VENUES = 'add-venues',
}

type Props = {
  brand: Brand;
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (values: FormValues) => void;
};

const venueGroupValidationSchema = createEditVenueGroupSchema();

export const AddVenueGroupModal = ({ onSubmit, isOpen, onClose, brand }: Props) => {
  const [step, setStep] = useState<FormStep>(FormStep.CREATE_VENUE_GROUP);
  const { venues, isLoading, error } = useGetBrandVenues({ brand });

  useEffect(() => {
    if (isOpen) {
      setStep(FormStep.CREATE_VENUE_GROUP);
    }
  }, [isOpen]);

  return (
    <WoltModal isOpen={isOpen} onRequestClose={onClose}>
      <Form<FormValues>
        validate={validateYupSchema(venueGroupValidationSchema)}
        onSubmit={onSubmit}
        render={({ handleSubmit }) => {
          if (isLoading) {
            return (
              <ModalContent>
                <Loading />
              </ModalContent>
            );
          }

          if (error) {
            return (
              <ModalContent>
                <Error>
                  <FormattedMessage id="venue-groups.error" />
                </Error>
              </ModalContent>
            );
          }

          return (
            <form onSubmit={handleSubmit}>
              {step === 'create-venue-group' && (
                <AddEditVenueGroup onClick={() => setStep(FormStep.ADD_VENUES)} onClose={onClose} />
              )}

              {step === 'add-venues' && (
                <AddVenuesToVenueGroup
                  venues={venues}
                  onBackClick={() => setStep(FormStep.CREATE_VENUE_GROUP)}
                  onClose={onClose}
                  displayCancelButton={false}
                />
              )}
            </form>
          );
        }}
      />
    </WoltModal>
  );
};
